import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { SiteSettingsProvider } from "./context/SiteSettingsContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Reparation from "./pages/Reparation";
import Peinture from "./pages/Peinture";
import Entretien from "./pages/Entretien";
import Prestations from "./pages/Prestations";
import Contact from "./pages/Contact";

// Admin pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPipeline from "./pages/admin/AdminPipeline";
import AdminDevis from "./pages/admin/AdminDevis";
import AdminDevisDetail from "./pages/admin/AdminDevisDetail";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminCMSFull from "./pages/admin/AdminCMSFull";
import AdminSEO from "./pages/admin/AdminSEO";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminPrestations from "./pages/admin/AdminPrestations";
import AdminPlanning from "./pages/admin/AdminPlanning";
import AdminTechniciens from "./pages/admin/AdminTechniciens";
import AdminInterventions from "./pages/admin/AdminInterventions";
import AdminFacturation from "./pages/admin/AdminFacturation";
import AdminPaiements from "./pages/admin/AdminPaiements";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main className="main-content">
      {children}
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <HelmetProvider>
    <SiteSettingsProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/reparation" element={<PublicLayout><Reparation /></PublicLayout>} />
            <Route path="/peinture" element={<PublicLayout><Peinture /></PublicLayout>} />
            <Route path="/entretien" element={<PublicLayout><Entretien /></PublicLayout>} />
            <Route path="/prestations" element={<PublicLayout><Prestations /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/pipeline" element={<AdminPipeline />} />
            <Route path="/admin/devis" element={<AdminDevis />} />
            <Route path="/admin/devis/:id" element={<AdminDevisDetail />} />
            <Route path="/admin/planning" element={<AdminPlanning />} />
            <Route path="/admin/techniciens" element={<AdminTechniciens />} />
            <Route path="/admin/interventions" element={<AdminInterventions />} />
            <Route path="/admin/facturation" element={<AdminFacturation />} />
            <Route path="/admin/paiements" element={<AdminPaiements />} />
            <Route path="/admin/contacts" element={<AdminContacts />} />
            <Route path="/admin/prestations" element={<AdminPrestations />} />
            <Route path="/admin/cms" element={<AdminCMSFull />} />
            <Route path="/admin/seo" element={<AdminSEO />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
          </Routes>
        </BrowserRouter>
      </div>
    </SiteSettingsProvider>
    </HelmetProvider>
  );
}

export default App;
